import React, { Fragment } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Routes } from '../../../../constants';
import { NewProfileButton, NavLinkOverride } from './styles';

export interface IProps {
  isDisabled: boolean
}

const NewProfileMenu: React.FC<IProps> = (props: IProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { isDisabled } = props;

  // TODO: i18n
  return (
    <>
      <NewProfileButton variant="primaryOnWhite" disabled={isDisabled} onClick={handleClick}>New</NewProfileButton>
      <Menu id="newProfileMenu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>

        <NavLinkOverride to={{ pathname: Routes.PUBLISH_PROFILES_NEW_YOUTUBE }}>
          <MenuItem id="newYoutubeItem" onClick={handleClose}>
            YouTube
          </MenuItem>
        </NavLinkOverride>

        <NavLinkOverride to={{ pathname: Routes.PUBLISH_PROFILES_NEW_TWITTER }}>
          <MenuItem id="newTwitterItem" onClick={handleClose}>
            X
          </MenuItem>
        </NavLinkOverride>

        <NavLinkOverride to={{ pathname: Routes.PUBLISH_PROFILES_NEW_LAN }}>
          <MenuItem id="newSanItem" onClick={handleClose}>
            LAN/SAN
          </MenuItem>
        </NavLinkOverride>

        <NavLinkOverride to={{ pathname: Routes.PUBLISH_PROFILES_NEW_YAHOO }}>
          <MenuItem id="newYahooItem" onClick={handleClose}>
            Yahoo MRSS
          </MenuItem>
        </NavLinkOverride>

      </Menu>
    </>
  );
};

export default NewProfileMenu;
